import axios from "axios";
import { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Footer } from "../componentes/footer";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReCAPTCHA from "react-google-recaptcha";

import fondo from "../img/fondo.jpg";
import logo from "../img/logo.png";

const KEY_CAPTCHA = process.env.REACT_APP_CLAVE_RECAPTCHA;
const URI =
  process.env.REACT_APP_DOMINIO + process.env.REACT_APP_PUERTO + "/password";

const MySwal = withReactContent(Swal);

export const CompRecCont = () => {
  const [dniLogin, setDniLogin] = useState("");
  const [passLogin, setPassLogin] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const navigate = useNavigate();
  const recaptchaRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const recuperarContrasenia = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (!captchaToken) {
      MySwal.fire({
        text: "Por favor, completa el reCAPTCHA.",
        confirmButtonText: "Ok",
      });
      return;
    }

    try {
      const logearse = await axios.post(
        URI,
        {
          dni: dniLogin,
          token: captchaToken,
        },
        {
          withCredentials: true,
          credentials: "include",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        }
      );

      if (logearse.data.code === 200) {
        setIsLoading(false);
        MySwal.fire({
          text: "Contraseña enviada",
          imageHeight: 65,
          confirmButtonText: "Ok",
          icon: "success",
          customClass: {
            confirmButton: "btn-confirmar",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/");
          }
        });
      } else if (logearse.data.code === 404) {
        setIsLoading(false);

        MySwal.fire({
          text: "Usted no dispone de un correo electrónico, contáctese con administración",
          imageHeight: 50,
          confirmButtonText: "Ok",
          icon: "error",
          customClass: {
            confirmButton: "btn-confirmar",
          },
        });
      } else if (logearse.data.code === 403) {
        setIsLoading(false);

        MySwal.fire({
          text: "Captcha inválido",
          imageHeight: 50,
          confirmButtonText: "Ok",
          icon: "error",
          customClass: {
            confirmButton: "btn-confirmar",
          },
        });
      }
    } catch (error) {
      setIsLoading(false);

      MySwal.fire({
        text: "Error en el inicio de sesión",
        confirmButtonText: "Ok",
        icon: "error",
        customClass: {
          confirmButton: "btn-confirmar",
        },
      });
    }
  };

  return (
    <>
    <div
       className="body"
    style={{
      margin: "auto",
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}>
      <div
        className="container-login-nuevo text-center p-0"
        style={{
          width: "100%",
          maxWidth: "22em",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <div className="form-container">
          <img src={logo} alt="Logo" className="form-logo " />
          <h5 className="form-title">Ingrese su DNI</h5>

          {isLoading ? (
            "Enviando contraseña"
          ) : (
            <form
              className="form-login"
              id="LoginForm"
              onSubmit={recuperarContrasenia}
            >
              <input
                type="number"
                placeholder={"DNI"}
                id="dniLogin"
                className="input-login"
                onChange={(e) => setDniLogin(e.target.value)}
                value={dniLogin}
                required
              />{" "}
              <div className="recaptcha-container">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={KEY_CAPTCHA}
                  onChange={handleCaptchaChange}
                />
              </div>
              <button type="submit" className="btn-login">
                {"Solicitar nueva contraseña"}
              </button>
            </form>
          )}
        </div>{" "}
      </div>
    </div>
    <Footer />
    </>
  );
};
